import {api} from "../app/api.js";

export class MotorAkkuService
{
  model;

  constructor(model)
  {
    this.model = model;
  }

  async SendGetGyártmányok() {
    return api.post('MotorAkku', 'GetGyártmányok', {});
  }

  async SendGetModellek() {
    return api.post('MotorAkku', 'GetModellek', { Gyártmány: this.model.Gyártmány });
  }

  async SendGetTípusok() {
    return api.post('MotorAkku', 'GetTípusok', { Gyártmány: this.model.Gyártmány, Modell: this.model.Modell, Ccm: this.model.Ccm });
  }

  async SendGetCcmek() {
    return api.post('MotorAkku', 'GetCcmek', { Gyártmány: this.model.Gyártmány, Modell: this.model.Modell });
  }

  async SendGetLinkek() {
    return api.post('MotorAkku', 'GetAkkuLinkek', this.model);
  }
}
